var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSave = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 15.833V4.167c0-.92.746-1.667 1.667-1.667h9.31c.441 0 .865.176 1.178.488l2.357 2.357c.312.313.488.737.488 1.179v9.31c0 .92-.746 1.666-1.667 1.666H4.167c-.92 0-1.667-.746-1.667-1.667Z",
  stroke: "currentColor",
  strokeWidth: 1.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.166 7.5h5.667a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H7.166a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5ZM5 11.334v6.167h10v-6.167a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5Z",
  stroke: "currentColor",
  strokeWidth: 1.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export default ForwardRef;